export enum EActiveCommentType {
  replying = 'replying',
  editing = 'editing',
}